import Component from 'gia/Component';

export default class Header extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      mobileMenu: {},
      buttonOpenMenu: {},
      buttonCloseMenu: {}
    };
  }

  mount() {
    let that = this;

    console.log('mounted');

    this.ref.buttonCloseMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.add('hidden');
    })

    this.ref.buttonOpenMenu.addEventListener('click', function() {
      that.ref.mobileMenu.classList.remove('hidden');
    })

  }


}